import Configuration from "./Configuration/Configuration";
import Colors from "./Colors/Colors";

import Mountings from "./Windows/Mountings";
import ProductSize from "./ProductSize/ProductSize";

function UserInterface(props) {
  return (
    <div className={`panel-container panel-${props.documentDirection}`}>
      <Configuration />
      <Colors />
      <ProductSize />
      <Mountings />
    </div>
  );
}

export default UserInterface;
